// Aceptación de Términos y Privacidad en el alta.
//
// La casilla se marca ANTES de que exista sesión, así que la aceptación no se
// puede registrar en el servidor en ese momento: se deja anotada aquí y
// LegalGate.jsx la registra en cuanto hay sesión. Dos vías, porque el alta
// tiene dos formas de completarse:
//  - Google/Apple: se vuelve al mismo navegador → marca en localStorage.
//  - Email: el correo de confirmación puede abrirse en otro dispositivo → las
//    versiones aceptadas viajan además en los metadatos del signUp.
// Si ninguna de las dos llega (o la versión ya no es la vigente), LegalGate
// simplemente muestra la pantalla de aceptación.

const PENDING_KEY = 'nivela_legal_accepted'
// La marca solo vale para el alta que se está haciendo ahora mismo: si se
// abandona a medias, no debe servir para otra cuenta que entre más tarde
// desde este mismo navegador.
const PENDING_TTL_MS = 30 * 60 * 1000

// Enlaces de reserva si no se pudo consultar la versión vigente al servidor.
export const LEGAL_FALLBACK_DOCS = {
  terms: { version: null, url: 'https://nivelaai.com/terms.html' },
  privacy: { version: null, url: 'https://nivelaai.com/privacy.html' },
}

export function legalVersions(docs) {
  const terms = docs?.terms?.version
  const privacy = docs?.privacy?.version
  return terms && privacy ? { terms, privacy } : null
}

export function markLegalAccepted(docs) {
  const versions = legalVersions(docs)
  if (!versions) return
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify({ ...versions, at: Date.now() }))
  } catch { /* ignore */ }
}

export function clearPendingLegal() {
  try { localStorage.removeItem(PENDING_KEY) } catch { /* ignore */ }
}

function readPendingLegal() {
  try {
    const v = JSON.parse(localStorage.getItem(PENDING_KEY) || 'null')
    if (!v || Date.now() - (v.at || 0) > PENDING_TTL_MS) return null
    return v
  } catch {
    return null
  }
}

// ¿Aceptó este usuario, en el alta, exactamente las versiones vigentes?
export function acceptedAtSignup(docs, user) {
  const current = legalVersions(docs)
  if (!current) return false
  const matches = (v) => !!v && v.terms === current.terms && v.privacy === current.privacy
  return matches(readPendingLegal()) || matches(user?.user_metadata?.legal)
}
